export default "__VITE_ASSET__d097dd13__"